<template>
  <div class="game-container">
    <div id="mainImage" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div class="titleTxt">{{ startData.title }}</div>
    <div
      class="text"
      id="selecteble"
      v-html="text"
      @mousedown="startSelect"
      @mouseup="stopSelect"
      @mouseover="moveSelect"
      :class="[{ 'block-game-after-correct': gameStatus }]"
    ></div>
    <div class="author">{{ startData.author }}</div>
    <div class="text" v-html="selected"></div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as fJS from '../../mixins/cjsRoot/fJS';
export default {
  name: 'mp-text-select',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      startData: {},
      text: '',
      imageData: null,
      selected: '',
      correct: null,
      initData: {},
      gameStatus: false,
    };
  },
  beforeMount() {
    this.initGame();
    this.newGame();
    this.imageData = this.startGameConfig.mainImage;
  },
  mounted() {},
  methods: {
    initGame() {
      this.startData = _.cloneDeep(this.startGameConfig.sample[0]);
      this.startData.loadTxt = '';
      const letters = this.startData.txt.split('');
      var br = '&nbsp;';
      for (let i = 0; i < letters.length; i++) {
        if (letters[i] == '<' && letters[i + 1] == 'b') {
          this.startData.loadTxt += br;
          i += 4;
        }
        if (i > letters.length) break;
        this.startData.loadTxt += '<span class="e">' + letters[i] + '</span>';
      }
      this.correct = document.createElement('div');
      const cor = this.startData.txt2.split('');
      let regExp = /[a-zA-Z,.:;„”–—\-+ąĄżŻśŚźŹęĘćĆńŃóÓłŁ ]|<#>|<\/#>|&nbsp;/g;
      const test = regExp.exec(this.startData.txt2);
      // const test = this.startData.txt2.split(regExp);
      console.log('test', test);
      var cls = 'e';
      this.selected = '';
      for (let i = 0; i < cor.length; i++) {
        if (cor[i] == '<' && cor[i + 1] == '#') {
          cls = 'g';
          i += 3;
        }
        if (cor[i] == '<' && cor[i + 1] == '/') {
          cls = 'e';
          i += 4;
        }
        if (i > cor.length) break;
        let span = document.createElement('span');
        span.className = cls;
        span.appendChild(document.createTextNode(cor[i]));
        this.correct.appendChild(span);
        this.selected += '<span class="' + cls + '">' + cor[i] + '</span>';
      }
    },
    newGame() {
      this.gameStatus = false;
      this.initData = { mouseDown: false, move: false, child: -1 };
      //            this.text = '';
      //            this.text = this.startData.loadTxt.slice(0);
      this.$set(this, 'text', this.startData.loadTxt.slice(0));
    },
    findIndxChild(nodes, child) {
      var indx = -1;
      nodes.forEach(function(node, i) {
        if (node == child) {
          indx = i;
          return;
        }
      });
      return indx;
    },
    startSelect(e) {
      /**
       * if checkStatus is active, reset it
       */
      this.resetCheckStatus();
      if (e.target.tagName.toLowerCase() !== 'span') return;
      this.initData.mouseDown = true;
      this.initData.child = this.findIndxChild(e.target.parentNode.childNodes, e.target);
      switch (e.target.className) {
        case 'e':
          e.target.className = 's';
          break;
        case 'g':
          break;
        default:
          e.target.className = 'e';
      }
      e.preventDefault();
      this.text = document.getElementById('selecteble').innerHTML;
    },
    stopSelect(e) {
      this.initData.mouseDown = false;
      if (!this.initData.move) return;
      else this.initData.move = false;
      this.initData.child = -1;
      e.preventDefault();
    },
    moveSelect(e) {
      if (e.target.tagName.toLowerCase() !== 'span') return;
      if (!this.initData.mouseDown) return;
      if (!this.initData.move) this.initData.move = true;
      let indx = this.findIndxChild(e.target.parentNode.childNodes, e.target);
      var clss = e.target.parentNode.childNodes[this.initData.child].className;
      if (Math.abs(this.initData.child - indx) > 0) {
        if (indx > this.initData.child) {
          for (let i = this.initData.child + 1; i <= indx; i++) {
            clss = 's';
            if (e.target.parentNode.childNodes[i].className != 'g') {
              e.target.parentNode.childNodes[i].className = clss;
            }
          }
        } else {
          for (let i = this.initData.child; i >= indx; i--) {
            if (clss == 'b') clss = 's';
            if (e.target.parentNode.childNodes[i].className != 'g') {
              e.target.parentNode.childNodes[i].className = clss;
            }
          }
        }
      }
      e.preventDefault();
      this.text = document.getElementById('selecteble').innerHTML;
    },
    checkWrongs() {
      let check = document.getElementById('selecteble');
      var self = this;
      check.childNodes.forEach(function(node, i) {
        if (node.className == 's') {
          if (self.correct.childNodes[i].className != 'g') {
            node.className = 'b';
          } else {
            if (
              check.childNodes[i - 1] != null &&
              ((check.childNodes[i - 1].className == 's' && self.correct.childNodes[i - 1].className != 'g') ||
                check.childNodes[i - 1].className == 'b')
            ) {
              node.className = 'b';
            }
            if (
              check.childNodes[i + 1] != null &&
              ((self.correct.childNodes[i + 1].className == 'g' && check.childNodes[i + 1].className == 'e') ||
                (self.correct.childNodes[i + 1].className != 'g' && check.childNodes[i + 1].className == 's'))
            ) {
              for (let j = i; j >= 0; j--) {
                if (check.childNodes[j].className == 's' || check.childNodes[j].className == 'g')
                  check.childNodes[j].className = 'b';
                else break;
              }
            }
          }
        }
      });
    },
    /**
     * uncheck all WRONGCOLOR class and reset to default
     * @method uncheckWrongs
     */
    uncheckWrongs() {
      let arrayElem = document.querySelectorAll('.b');
      arrayElem.forEach(function(item) {
        item.classList.remove('b');
        item.classList.add('e');
      });
    },
    /**
     * check for wrong selection and if time is set reset it after delay
     * @method checkWrongsAction
     * @param  {Number}          time delay in miliseconds
     */
    checkWrongsAction(time) {
      /** default checkWrongs function */
      this.checkWrongs();
      /** if delay time exist and is a Number */
      if (_.isNumber(time)) {
        setTimeout(() => {
          this.uncheckWrongs();
        }, time);
      }
    },
    checkGood() {
      let check = document.getElementById('selecteble');
      check.childNodes.forEach(function(node, i) {
        if (node.className == 's') {
          node.className = 'g';
        }
      });
    },
    clearChecks() {
      let check = document.getElementById('selecteble');
      check.childNodes.forEach(function(node, i) {
        if (node.className == 'b' || node.className == 's') {
          node.className = 'e';
        }
      });
    },
    resetGameAction() {
      this.newGame();
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    checkGameAction() {
      var isCorrect = true;
      let check = document.getElementById('selecteble');
      var self = this;
      check.childNodes.forEach(function(node, i) {
        if (node.className == 'b') node.className = 's';
      });
      /** search and mark wrong selection */
      this.checkWrongsAction(1000);
      if (this.startGameConfig.showGood) this.checkGood();
      check.childNodes.forEach(function(node, i) {
        if (node.className == 'b' || (node.className == 'e' && self.correct.childNodes[i].className == 'g')) {
          isCorrect = false;
        }
      });
      if (isCorrect) {
        check.childNodes.forEach(function(node, i) {
          node.className = self.correct.childNodes[i].className;
        });
      } else if (this.startGameConfig.isClear && !this.startGameConfig.showWrong) {
        this.clearChecks();
      }
      this.text = check.innerHTML;
      this.gameStatus = isCorrect;
      return isCorrect;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 1080,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1920,
          });
        }
      } else {
        return 'display : none;';
      }
      return _.merge({ position: 'absolute', left: '0' }, this.getCustomStyle(imageData), {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${this.giveMeImagePlease(
          imageData.imagePath
        )}`)})`,
        top: fJS.isNumeric(imageData.pos.y)
          ? imageData.pos.y + 'px'
          : fJS.isNumeric(imageData.offsetVertical)
          ? imageData.offsetVertical
          : 0,
        left: fJS.isNumeric(imageData.pos.x)
          ? imageData.pos.x + 'px'
          : fJS.isNumeric(imageData.offsetHorizontal)
          ? imageData.offsetHorizontal
          : 0,
        width: fJS.isNumeric(imageData.width) ? imageData.width + 'px' : '100%',
        height: fJS.isNumeric(imageData.height) ? imageData.height + 'px' : '100%',
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function(value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    giveMeImagePlease(p) {
      let path = require('path');
      let imgPath = p;
      imgPath = imgPath.replace('static/', '');
      imgPath = path.normalize(imgPath);
      return imgPath;
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function(newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss">
.e {
  background-color: transparent;
  cursor: pointer;
}

.s {
  background-color: #82eeff;
  cursor: pointer;
}

.b {
  background-color: #fc3a3a;
  cursor: pointer;
}

.g {
  background-color: #50ff47;
  cursor: not-allowed;
}
</style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 200px 100px 100px;
  flex-direction: column;
  justify-content: top;
  width: 100%;
  height: 100%;
}

.game-container .titleTxt {
  top: 0;
  font-weight: bolder;
  font-size: 1.5em;
  margin-bottom: 50px;
}

.game-container .text {
  text-align: justify;
}

.game-container .author {
  font-style: italic;
  font-weight: normal;
  font-size: 0.7em;
  text-align: right;
  margin-top: 50px;
}
.block-game-after-correct {
  pointer-events: none;
}
.main-image-container,
.main-txt-container {
  display: block;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
